import React, { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';

import { gameResourcesService } from '../../../services/gameResourcesService';

function WinLine({ containerConfig }) {
  const winLineContainerRef = useRef(null);

  useEffect(() => {
    if (winLineContainerRef.current) gameResourcesService.setupAllLine(winLineContainerRef.current);
  }, [winLineContainerRef]);

  return <Container visible ref={winLineContainerRef} {...containerConfig} name='WinLine' />;
}

export default WinLine;
